import React from "react";
import classesModal from "./CheckoutModal.module.scss";
import classes from "../../FormChooseMySeats/ScheduleSelection/ScheduleSelection.module.scss";
import closeIcon from "../../../assets/images/closeIcon.png";
import cx from "classnames";
const CheckoutModalSchedule = (props) => {
  let scheduleSelectionSelect = {
    plan: [
      {
        title:
          props.formSize === "eightyClassic"
            ? props.planSchedules["xa79PAlovb"].planTitle
            : props.planSchedules["soof513JuY"].planTitle,
        description:
          props.formSize === "eightyClassic"
            ? props.planSchedules["xa79PAlovb"].planDesc
            : props.planSchedules["soof513JuY"].planDesc,
        games:
          props.formSize === "eightyClassic"
            ? props.planSchedules["xa79PAlovb"].games
            : props.planSchedules["soof513JuY"].games,
      },
    ],
  };

  let scheduleSelectionBody =
    scheduleSelectionSelect !== ""
      ? scheduleSelectionSelect.plan.map((res, index) => (
          <div
            key={index}
            className={cx(
              classes.scheduleSelectionPlan,
              classes.scheduleSelectionOneCol
            )}
          >
            <div className={classes.scheduleSelectionPlanTitle}>
              {res.title}
            </div>
            <div className={classes.scheduleSelectionPlanDescription}>
              <span>{res.description}</span>
            </div>
            {res.games && res.title !== "Build Your Own Plan" && (
              <>
                <div className={classes.scheduleSelectionPlanGames}>
                  <h3>Schedule</h3>
                  <ul>
                    {res.games.map((game, i) => {
                      return <li key={i + 100}>{game}</li>;
                    })}
                  </ul>
                  {/* <p className={classes.scheduleFootnote}>
                    Note: Plan excludes the MLB Little League Classic, which
                    the Nationals will play on August 20 in Williamsport, PA.
                    Ticketing details to be announced at a later date.
                  </p> */}
                </div>
              </>
            )}
          </div>
        ))
      : "";

  return (
    <div
      className={cx(
        classesModal.modal,
        props.checkoutModalScheduleToggle === true
          ? classesModal.modalActive
          : ""
      )}
    >
      <div className={classes.modaBody}>
        <div className={classes.scheduleSelection}>
          <div className={classes.scheduleSelectionTitle}>game schedule</div>
          <div className={classes.scheduleSelectionPlanWrapper}>
            {scheduleSelectionBody}
          </div>
          {/* {(props.formSize === "eightyClassic" ||
            props.formSize === "fortyClassic" ||
            props.formSize === "twentyClassic") && (
            <div className={classes.scheduleSelectionDisclaimer}>
              All 2021 access, benefits, promotions, seating locations, and
              events (including, without limitation, location, dates and times)
              are subject to change without notice based on the ongoing
              developments of the COVID-19 pandemic.
            </div>
          )} */}
          <img
            className={classes.closeIcon}
            src={closeIcon}
            alt="Close Icon"
            onClick={() => props.onClickCheckoutModalScheduleToggle()}
          />
        </div>
      </div>
    </div>
  );
};

export default CheckoutModalSchedule;
